import React, { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Link } from "react-router-dom";
import { BUTTONS, HEADINGS, LABELS, THEME_MODAL_TEXTS } from "@/utils/constants/appConstants/commonConstants";
import ColorPicker from "@/components/popover/ColorPicker";
import { errorToasterMessage } from "@/utils/functions/toaster";
import { UPLOAD_IMAGE_REQUIRED } from "@/utils/constants/messages";
import { COLORS, DEFAULT_THEME_COLORS } from "@/utils/constants/colors";
interface CreateThemeModalProps {
    show?: boolean;
    onHide?: () => void;
    emailFile?: any;
    signingFile?: any;
    emailImage?: any;
    signingImage?: any;
    onFileSelect?: any;
    onFileSelect2?: any;
    headerBg?: string;
    headerText?: string;
    buttonBg?: string;
    buttonText?: string;
    setHeaderBg?: any;
    setHeaderText?: any;
    setButtonBg?: any;
    setButtonText?: any;
}

const CreateThemeModal: React.FC<CreateThemeModalProps> = (props) => {
    const [activeTab, setActiveTab] = useState<"signing" | "email">("signing");
    const [otherActionsOpen, setOtherActionsOpen] = useState(false);
    const headerBg = props.headerBg ?? DEFAULT_THEME_COLORS.headerBg;
    const headerText = props.headerText ?? DEFAULT_THEME_COLORS.headerText;
    const buttonBg = props.buttonBg ?? DEFAULT_THEME_COLORS.buttonBg;
    const buttonText = props.buttonText ?? DEFAULT_THEME_COLORS.buttonText;

    const handleApplyBrand = () => {
        if (!props.emailFile || !props.signingFile) {
            errorToasterMessage(UPLOAD_IMAGE_REQUIRED);
            return;
        }
        props.onHide?.();
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent
                className="gs-create-theme-dialog"
                onInteractOutside={(event) => {
                    const target = event.target as HTMLElement | null;
                    if (
                        target?.closest('[data-slot="dropdown-menu-content"]') ||
                        target?.closest('[data-slot="dropdown-menu-trigger"]') ||
                        target?.closest('[data-radix-popper-content-wrapper]')
                    ) {
                        event.preventDefault();
                    }
                }}
            >
                <div className="gs-create-theme-dialog__header">
                    <h4 className="gs-create-theme-dialog__title" id="create-theme-heading">
                        {HEADINGS.CUSTOMIZE_SIGNING_EMAIL}
                    </h4>
                </div>

                <div className="gs-create-theme-dialog__body">
                    <div className="gs-create-theme-dialog__layout">
                        <div className="gs-create-theme-dialog__sidebar">
                            <h5 className="mb-3 text-sm font-semibold text-secondary" id="create-theme-logo">
                                {HEADINGS.LOGOS}
                            </h5>

                            <div className="gs-create-theme-dialog__section-block">
                                <p className="mb-1 text-xs font-semibold uppercase text-card-foreground" id="create-theme-signing-logo">
                                    {LABELS.SIGNING_LOGO}
                                </p>
                                <input
                                    id="create-theme-signing-logo-input"
                                    onChange={props.onFileSelect2}
                                    accept="image/*"
                                    type="file"
                                    name="uploadfile"
                                    className="hidden"
                                />
                                <label
                                    id="create-theme-signing-logo-label"
                                    className="gs-create-theme-dialog__upload-label"
                                    htmlFor="create-theme-signing-logo-input"
                                >
                                    {LABELS.UPLOAD_SIGNING_LOGO}
                                </label>
                                <p className="text-xs text-muted-foreground" id="create-theme-signing-logo-name">
                                    {props.signingImage?.name}
                                </p>
                            </div>

                            <div className="gs-create-theme-dialog__section-block">
                                <p className="mb-1 text-xs font-semibold uppercase text-card-foreground" id="create-theme-email-logo">
                                    {LABELS.EMAIL_LOGO}
                                </p>
                                <input
                                    id="create-theme-email-logo-input"
                                    onChange={props.onFileSelect}
                                    accept="image/*"
                                    type="file"
                                    name="uploadfile"
                                    className="hidden"
                                />
                                <label
                                    id="create-theme-email-logo-label"
                                    className="gs-create-theme-dialog__upload-label"
                                    htmlFor="create-theme-email-logo-input"
                                >
                                    {LABELS.UPLOAD_EMAIL_LOGO}
                                </label>
                                <p className="text-xs text-muted-foreground" id="create-theme-email-logo-name">
                                    {props.emailImage?.name}
                                </p>
                            </div>

                            <h5 className="mb-3 text-sm font-semibold text-secondary">Colors</h5>
                            <div>
                                <div className="gs-create-theme-dialog__color-row" id="create-theme-header-background-color">
                                    <ColorPicker color={headerBg} name="headerBg" setHeaderBg={props.setHeaderBg} className="user-avatar" />
                                    <span className="text-xs text-card-foreground" id="create-theme-header-background">Header Background</span>
                                </div>
                                <div className="gs-create-theme-dialog__color-row" id="create-theme-header-text-color">
                                    <ColorPicker color={headerText} name="headerText" setHeaderText={props.setHeaderText} className="user-avatar" />
                                    <span className="text-xs text-card-foreground" id="create-theme-header-text">Header Text</span>
                                </div>
                                <div className="gs-create-theme-dialog__color-row" id="create-theme-button-background-color">
                                    <ColorPicker color={buttonBg} name="buttonBg" setButtonBg={props.setButtonBg} className="user-avatar" />
                                    <span className="text-xs text-card-foreground" id="create-theme-button-background">Button Background</span>
                                </div>
                                <div className="gs-create-theme-dialog__color-row" id="create-theme-button-text-color">
                                    <ColorPicker color={buttonText} name="buttonText" setButtonText={props.setButtonText} className="user-avatar" />
                                    <span className="text-xs text-card-foreground" id="create-theme-button-text">Button Text</span>
                                </div>
                            </div>
                        </div>

                        <div className="gs-create-theme-dialog__main">
                            <div className="gs-page-tabs gs-create-theme-dialog__tabs mb-3">
                                <button
                                    type="button"
                                    className={`gs-page-tab${activeTab === "signing" ? " gs-page-tab--active" : ""}`}
                                    onClick={() => setActiveTab("signing")}
                                    id="create-theme-signing-tab"
                                >
                                    {HEADINGS.SIGNING}
                                </button>
                                <button
                                    type="button"
                                    className={`gs-page-tab${activeTab === "email" ? " gs-page-tab--active" : ""}`}
                                    onClick={() => setActiveTab("email")}
                                    id="create-theme-email-tab"
                                >
                                    {HEADINGS.EMAIL}
                                </button>
                            </div>

                            {activeTab === "signing" && (
                                <div>
                                    <h6 className="mb-2 text-xs font-semibold text-card-foreground" id="create-theme-signing-tab-preview">
                                        PREVIEW
                                    </h6>
                                    <div className="mb-3 border border-muted">
                                        <div
                                            style={{ height: "62px", backgroundColor: props.headerBg }}
                                            className="flex items-center justify-between px-4"
                                        >
                                            <h5 style={{ fontSize: "15px", color: props.headerText }} id="create-theme-signing-tab-sub-text">
                                                Select Finish to send the completed document.
                                            </h5>
                                            <div className="gs-create-theme-dialog__preview-actions">
                                                <button
                                                    type="button"
                                                    className="gs-create-theme-dialog__finish-btn"
                                                    style={{ color: props.buttonText, backgroundColor: props.buttonBg }}
                                                    id="create-theme-finish-btn"
                                                >
                                                    Finish
                                                </button>
                                                <DropdownMenu modal={false} open={otherActionsOpen} onOpenChange={setOtherActionsOpen}>
                                                    <DropdownMenuTrigger asChild>
                                                        <button
                                                            id="create-theme-other-actions-trigger"
                                                            type="button"
                                                            className="gs-create-theme-dialog__other-actions-trigger border-0 bg-transparent text-sm text-white"
                                                        >
                                                            Other Actions {otherActionsOpen ? "▴" : "▾"}
                                                        </button>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent
                                                        align="end"
                                                        sideOffset={6}
                                                        className="gs-create-theme-dialog__other-actions-menu z-[1300]"
                                                        onCloseAutoFocus={(event) => event.preventDefault()}
                                                    >
                                                        <DropdownMenuItem
                                                            id="create-theme-finish-later-option"
                                                            className="gs-create-theme-dialog__other-actions-item"
                                                        >
                                                            Finish Later
                                                        </DropdownMenuItem>
                                                        <DropdownMenuItem
                                                            id="create-theme-declined-to-sign-option"
                                                            className="gs-create-theme-dialog__other-actions-item gs-create-theme-dialog__other-actions-item--danger"
                                                        >
                                                            Decline to Sign
                                                        </DropdownMenuItem>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                                <Link to="/">
                                                    <img
                                                        id="create-theme-signing-logo-img"
                                                        height={30}
                                                        className="logo-img"
                                                        src={props.signingFile || "/images/white-logo.png"}
                                                        alt="logo"
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <img id="create-theme-page-img" className="w-full p-0" src="/images/signingpage.png" alt="signing preview" />
                                </div>
                            )}

                            {activeTab === "email" && (
                                <div>
                                    <h6 className="mb-2 text-xs font-semibold text-card-foreground" id="create-theme-email-tab-preview">
                                        PREVIEW
                                    </h6>
                                    <div className="border border-muted bg-white px-5 py-3">
                                        <table role="presentation" cellSpacing={0} cellPadding={0} width="100%">
                                            <tbody>
                                                <tr>
                                                    <td />
                                                    <td width={640}>
                                                        <table style={{ borderCollapse: "collapse", backgroundColor: COLORS.white, maxWidth: "640px" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ padding: "10px 24px" }}>
                                                                        {props.emailFile ? (
                                                                            <img id="create-theme-email-tab-email-logo" style={{ border: "none" }} width={116} src={props.emailFile} alt="Logo" />
                                                                        ) : (
                                                                            <img id="create-theme-email-tab-email-logo" style={{ border: "none" }} width={116} src="/images/logo.png" alt="GreenSign" />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "0px 24px 30px 24px" }}>
                                                                        <table role="presentation" cellSpacing={0} cellPadding={0} width="100%" style={{ backgroundColor: props.headerBg, color: COLORS.white }}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{ padding: "28px 36px 36px 36px", borderRadius: "2px", backgroundColor: props.headerBg, color: COLORS.white, fontSize: "16px", fontFamily: "Helvetica,Arial,Sans Serif", width: "100%", textAlign: "center" }} align="center">
                                                                                        <img id="create-theme-email-tab-account-logo" width={75} height={75} src="/images/accountActivation-white.png" style={{ width: "75px", height: "75px" }} alt="Account activation" />
                                                                                        <table role="presentation" cellSpacing={0} cellPadding={0} width="100%">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style={{ paddingTop: "24px", fontSize: "16px", fontFamily: "Helvetica,Arial,Sans Serif", border: "none", textAlign: "center", color: COLORS.white }} id="create-theme-email-tab-invite-to-registered">
                                                                                                        Invitation to register
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                        <table role="presentation" cellSpacing={0} cellPadding={0} width="100%">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td align="center" style={{ paddingTop: "30px" }}>
                                                                                                        <div>
                                                                                                            <table cellSpacing={0} cellPadding={0}>
                                                                                                                <tbody>
                                                                                                                    <tr>
                                                                                                                        <td align="center" height={44} style={{ fontSize: "15px", color: COLORS.textDark, backgroundColor: COLORS.emailButton, fontFamily: "Helvetica,Arial,Sans Serif", fontWeight: "bold", textAlign: "center", textDecoration: "none", borderRadius: "2px", display: "block" }}>
                                                                                                                            <a href="#" onClick={(e) => e.preventDefault()} style={{ fontSize: "15px", fontFamily: "Helvetica,Arial,Sans Serif", fontWeight: "bold", textAlign: "center", textDecoration: "none", borderRadius: "2px", backgroundColor: props.buttonBg, color: props.buttonText, display: "inline-block" }}>
                                                                                                                                <span style={{ padding: "0px 24px", lineHeight: "44px" }} id="create-theme-email-tab-accept-btn">Accept</span>
                                                                                                                            </a>
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                </tbody>
                                                                                                            </table>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "0px 24px 24px 24px", color: COLORS.black, fontSize: "16px", fontFamily: "Helvetica,Arial,Sans Serif", backgroundColor: "white" }}>
                                                                        <table style={{ margin: "0px auto" }} role="presentation" cellSpacing={0} cellPadding={0}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{ paddingBottom: "20px" }}>
                                                                                        <div style={{ fontFamily: "Helvetica,Arial,Sans Serif", fontWeight: "bold", lineHeight: "18px", fontSize: "15px", color: COLORS.textDark, textAlign: "center" }} id="create-theme-email-tab-invite-message">
                                                                                            You have been invited to register on GreenSign.
                                                                                        </div>
                                                                                        <div style={{ fontFamily: "Helvetica,Arial,Sans Serif", lineHeight: "18px", fontSize: "15px", color: COLORS.textMutedLong, textAlign: "center" }} id="create-theme-email-tab-invite-sub-message">
                                                                                            Please click the &apos;Accept&apos; button to set up account.
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "30px 24px 45px 24px", backgroundColor: COLORS.footerBg }} id="create-theme-email-tab-disclaimer-container">
                                                                        <p style={{ marginBottom: "1em", fontFamily: "Helvetica,Arial,Sans Serif", fontSize: "13px", color: COLORS.textMutedLong, lineHeight: "18px" }} id="create-theme-email-tab-donot-share-email-message">
                                                                            <b role="heading">{THEME_MODAL_TEXTS.DO_NOT_SHARE_EMAIL_MESSAGE}</b><br />{THEME_MODAL_TEXTS.SECURE_LINK_MESSAGE}<br />
                                                                        </p>
                                                                        <p style={{ marginBottom: "1em", fontFamily: "Helvetica,Arial,Sans Serif", fontSize: "13px", color: COLORS.textMutedLong, lineHeight: "18px" }} id="create-theme-email-tab-about-greensign-message">
                                                                            <b role="heading">{THEME_MODAL_TEXTS.ABOUT_GREENSIGN_MESSAGE}</b><br />{THEME_MODAL_TEXTS.SIGN_DOCUMENT_MESSAGE}
                                                                        </p>
                                                                        <p style={{ marginBottom: "1em", fontFamily: "Helvetica,Arial,Sans Serif", fontSize: "13px", color: COLORS.textMutedLong, lineHeight: "18px" }} id="create-theme-email-tab-question-about-doc-message">
                                                                            <b role="heading">{THEME_MODAL_TEXTS.QUESTION_ABOUT_DOC_MESSAGE}</b><br />{THEME_MODAL_TEXTS.MODIFY_DOCUMENT_MESSAGE}<br /><br />{THEME_MODAL_TEXTS.TROUBLE_SIGNING_DOCUMENT_MESSAGE}
                                                                            <a href="#" style={{ color: COLORS.linkBrand }} id="create-theme-email-tab-help-signing-link">&nbsp;support@greensign.com.</a><br />
                                                                        </p>
                                                                        <p style={{ marginBottom: "1em", fontFamily: "Helvetica,Arial,Sans Serif", fontSize: "13px", color: COLORS.textMutedLong, lineHeight: "18px" }} id="create-theme-email-tab-info-message">
                                                                            This message was sent to you by %%SENDERSNAME%% who is using the GreenSign Electronic Signature Service. If you would rather not receive email from this sender you may contact the sender with your request.
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td />
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="gs-create-theme-dialog__footer">
                    <Button id="create-theme-apply-brand-btn" type="button" className="uppercase" onClick={handleApplyBrand}>
                        {BUTTONS.APPLY}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CreateThemeModal;
